import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Enterprise from "@/pages/Enterprise";
import Universities from "@/pages/Universities";
import Government from "@/pages/Government";
import HowItWorks from "@/pages/HowItWorks";
import AIFeatures from "@/pages/AIFeatures";
import Teachers from "@/pages/Teachers";
import Events from "@/pages/Events";
import Pricing from "@/pages/Pricing";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import ReactGA from "react-ga4";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

function PageTracker() {
  const location = useLocation();
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/enterprise" element={<Enterprise />} />
            <Route path="/universities" element={<Universities />} />
            <Route path="/government" element={<Government />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/ai-features" element={<AIFeatures />} />
            <Route path="/teachers" element={<Teachers />} />
            <Route path="/events" element={<Events />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" richColors />
        <Link
        to="/contact"
        className="fixed bottom-6 right-6 z-50 flex items-center gap-2 px-5 py-3 rounded-full bg-primary text-primary-foreground text-sm font-semibold shadow-primary hover:bg-primary-dark"
        style={{ transition: "background var(--transition-fast), transform var(--transition-fast), box-shadow var(--transition-fast)" }}
        onMouseEnter={e => e.currentTarget.style.transform = "translateY(-2px)"}
        onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
      >
        <Mail className="w-4 h-4 shrink-0" />
        Talk to Our Team
      </Link>
      </div>
    </BrowserRouter>
  );
}

export default App;
